import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_CONFIG_LUMN_LIST } from './url-constants';

type getConfigureLuminairesListEndpointSpecifications = ApiEndpointSpecification;
export const getConfigureLuminairesListEndpointSpecification: getConfigureLuminairesListEndpointSpecifications = {
    url: GET_CONFIG_LUMN_LIST,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'GetConfigureLuminairesListRequestParams',
    requestBodySchemaName: 'GetConfigureLuminairesListRequestBody',
    okResponseSchemaName: 'GetConfigureLuminairesListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
}

export const invokeGetConfigureLuminairesList = Helpers.makeApiRequestFn<
    Types.GetConfigureLuminairesListRequestParams,
    Types.GetConfigureLuminairesListRequestBody,
    Types.GetConfigureLuminairesListOkResponse
>(getConfigureLuminairesListEndpointSpecification);
